// This modal box can be added to other things
// Will save and shut itself. And update redux store
// If a callback is given, will return id of saved or created customer

import * as React from 'react';
import { connect } from 'react-redux';

//import styles from './styles';
import { FlatList, TouchableHighlight, TouchableOpacity } from 'react-native';
import { Container, Header, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, List, ListItem, InputGroup } from 'native-base';

import * as _ from 'lodash';
import Modal from '../../components/modal';

import styles from './busTypeStyles';

//import diff from 'object-diff';

export default class BusTypeContainer extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			isLoading: true,
			isSearching: false,
			isActive: !props.disableInit,
			searchString: ''
		};
		this.state = this.initialState;
	}

	/*componentDidMount() {

		//this.setState({details});

	}

	componentWillReceiveProps(nextProps){


	}

	shouldComponentUpdate(nextProps, nextState){


	}*/

	selectCurrent(id) {
		console.log('selected', id);
		this.props.input.onChange(id);
		this.setState({ isActive: false });
	}

	clearSearch() {
		this.setState({ searchString: '' });
		this.sbox._root.clear();
	}

	doSearch(query) {
		if (!query || query === '') {
			return [];
		}

		const { data } = this.props;
		const regex = new RegExp(`${query.trim()}`, 'i');
		//this.props.input.onChange(query); //send to reduxform
		return data.filter(item => item.name.search(regex) >= 0 || item.id == 742);
	}

	render() {
		const searching = this.state.searchString != '';
		const list = searching ? this.doSearch(this.state.searchString) : this.props.data.filter(item => item.mostCommon == 1);
		const {
			input: { onChange, onBlur, value, ...restInput },
			label,
			title,
			placeholder = 'Search',
			labelWidth = '30%',
			buttonText,
			disabled = false,
			type,
			meta: { touched, error }
		} = this.props;

		const bus = value && _.find(this.props.data, ['id', value]);
		const busType = bus && bus.name.split(/:|<\/?\w+>/)[0];

		if (this.state.isError) {
			return <Text style={{ color: 'red' }}>Error loading!</Text>;
		} else {
			return (
				<View style={{ flexDirection: 'row', alignItems: 'center' }}>
					<Label style={{ width: labelWidth, marginLeft: 5, paddingTop: 1, paddingRight: 5, color: '#2f6483' }}>{label}</Label>
					<Item style={{ flex: 1, paddingLeft: 5 }}>
						<Button transparent onPress={() => this.setState({ isActive: true })}>
							<Text style={{ fontSize: 17, paddingLeft: 0 }}>{!!bus ? busType : buttonText}</Text>
							<Modal isOpen={!!this.state.isActive} backButtonClose coverScreen swipeThreshold={100} style={styles.modalStyle} onClosed={() => this.setState({ isActive: false })}>
								{!this.state.isSaving ? (
									<Header style={styles.modalHeader}>
										<Body>
											<Title>{title}</Title>
										</Body>
									</Header>
								) : (
									<Header>
										<Spinner />
									</Header>
								)}
								<View style={styles.modalContainer}>
									<View style={styles.innerContainer}>
										<InputGroup>
											<Icon active name="search" />
											<Input
												placeholder={placeholder}
												ref={r => {
													this.sbox = r;
												}}
												onChangeText={searchString => this.setState({ searchString })}
											/>
											{searching && (
												<Button transparent onPress={() => this.clearSearch()}>
													<Icon name="close-circle" />
												</Button>
											)}
										</InputGroup>
										<Content>
											<FlatList
												data={list}
												keyExtractor={(item, index) => item.id}
												renderItem={({ item, id }) => (
													<ListItem key={id} button onPress={() => this.selectCurrent(item.id)}>
														{item.name.split(/<\/?\w+>/).map((val, i) =>
															i == 0 ? (
																<Text key={i}>{val}</Text>
															) : (
																<Text key={i} style={styles.smallText}>
																	{val}
																</Text>
															)
														)}
													</ListItem>
												)}
											/>
										</Content>
									</View>
								</View>
							</Modal>
						</Button>
					</Item>
				</View>
			);
		}
	}
}
